var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"its-structure"},[_c('p',{staticClass:"its-structure-title"},[_vm._v("数据驱动智慧教学 让教与学更高效")]),_c('img',{attrs:{"src":require("../../../../assets/images/home/home-part2-bg.png")}})])
}]

export { render, staticRenderFns }